import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainLayout from '@/layouts/MainLayout';
import Home from '@/pages/Home';
import { ComingSoonPage } from '@/pages/ComingSoonPage';

function App() {
  const { i18n } = useTranslation();
  // 言語を正規化: ja/en 以外は ja にフォールバック（v0.6.1）
  const lang = i18n.resolvedLanguage === 'en' ? 'en' : 'ja';

  return (
    <Routes>
      {/* デフォルトは日本語にリダイレクト */}
      <Route path="/" element={<Navigate to={`/${lang}`} replace />} />

      {/* 言語別ルート */}
      <Route path="/:lang" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="story" element={<ComingSoonPage />} />
        <Route path="contents" element={<ComingSoonPage />} />
        <Route path="events" element={<ComingSoonPage />} />
        <Route path="contact" element={<ComingSoonPage />} />
      </Route>

      {/* 404 - 日本語ホームにリダイレクト */}
      <Route path="*" element={<Navigate to="/ja" replace />} />
    </Routes>
  );
}

export default App;
